import { useQuery } from "@apollo/client";
import { Avatar, Button, Search, Spinner, Loader } from "../../common";
import "./EventsIndex.css";
import { EVENTS } from "../../../api/events";
import { Fragment } from "react";
import { useAppState } from "../../../utils/appState";
import CreateEvent from "../CreateEvent";
import { useHistory } from "react-router-dom";

export default function EventsIndex() {
  const history = useHistory();
  const [, setAppState] = useAppState();
  const { loading, error, data, refetch, networkStatus, variables, fetchMore } =
    useQuery(EVENTS(), {
      notifyOnNetworkStatusChange: true,
    });

  if (error) {
    return <div>Error</div>;
  }

  const items = data?.events || [];

  return (
    <div className="App-index-page">
      <div className="App-index-page__header">
        <div className="App-index-page__header__title">Events</div>

        <div className="App-index-page__header__options">
          <Search
            className="App-index-page__header__options__search"
            placeholder="Search events..."
            networkStatus={networkStatus}
            onSubmit={(val) => {
              refetch({
                where: { name: val },
              });
            }}
            onReset={() => {
              refetch({ where: undefined });
            }}
          />

          <Button
            label={"CREATE EVENT"}
            className="App-index-page__header__options__add"
            onClick={() => {
              setAppState({ modal: <CreateEvent /> });
            }}
          />
        </div>
      </div>

      <div className="App-index-page__list">
        {networkStatus === 1 || networkStatus === 2 ? (
          <div className="App-index-page__list__loading">
            <Spinner />
          </div>
        ) : (
          <Fragment>
            {items.map((item) => (
              <div
                className="App-index-page__list__item"
                onClick={() => {
                  history.push("/v2/events/view/" + item.id);
                }}
              >
                <div
                  className={
                    "App-index-page__list__item__img " +
                    (item.profilePhoto ? "no-bg" : "")
                  }
                >
                  {item.profilePhoto && <Avatar media={item.profilePhoto} />}
                </div>

                <div className="App-index-page__list__item__text">
                  <div className="App-index-page__list__item__text__primary">
                    {item.name}
                  </div>

                  <div className="App-index-page__list__item__text__secondary">
                    {item.organizedBy?.name}
                  </div>
                </div>
              </div>
            ))}

            {!!items.length && (
              <div
                className="App-index-page__list__item"
                onClick={() => {
                  fetchMore({
                    variables: {
                      ...variables,
                      cursor: items[items.length - 1].id,
                    },
                  });
                }}
                style={{ alignItems: "center", justifyContent: "center" }}
              >
                <div className="App-index-page__list__item__text">
                  <div className="App-index-page__list__item__text__secondary">
                    {networkStatus === 3 ? (
                      <Loader theme={"small grey"} />
                    ) : (
                      "Load More"
                    )}
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
}
